import styled from 'styled-components'

/**
 * Shared row/label layout for the LTA pre-planning form, so the form shell and
 * the extracted per-fact input line up without either owning the other's styles.
 */
export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`

export const Label = styled.span`
  width: 22rem;
  font-weight: 500;
`

// Shared control width, so the fact selects and the corrosion select stay
// consistent without repeating a magic literal inline.
export const SELECT_STYLE = { minWidth: '20rem' } as const
